import Vue from "vue";
import moment from "moment";

Vue.filter("capitalize", function (value) {
  if (!value) return "";
  value = value.toString();
  let arr = value.split(" ");
  let capitalized_array = [];
  arr.forEach((word) => {
    let capitalized = word.charAt(0).toUpperCase() + word.slice(1);
    capitalized_array.push(capitalized);
  });
  return capitalized_array.join(" ");
});

Vue.filter("lowercase", function (value) {
  if (!value) return "";
  return value.toLowerCase();
});

Vue.filter("truncate", function (value, limit) {
  if (!isNaN(parseFloat(value)) && isFinite(value)) return value;
  if (value == undefined) return "";
  return value.substring(0, limit);
});

Vue.filter("time", function (value, is24HrFormat = false) {
  if (value) {
    const date = new Date(Date.parse(value));
    let hours = date.getHours();
    const min = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
    if (!is24HrFormat) {
      const time = hours > 12 ? "AM" : "PM";
      hours = hours % 12 || 12;
      return hours + ":" + min + " " + time;
    }
    return hours + ":" + min;
  }
});

Vue.filter("date", function (value, fullDate = false) {
  value = String(value);
  const date = value.slice(8, 10).trim();
  const month = value.slice(4, 7).trim();
  const year = value.slice(11, 15);

  if (!fullDate) return date + " " + month;
  else return date + " " + month + " " + year;
});

Vue.filter("regularDate", function (value) {
  var minDate = moment.utc("0001-01-01");
  if (value == undefined) return moment();
  value = String(value);
  if (isValidTimestamp(value)) {
    return moment.unix(value / 1000).format("DD-MM-YYYY");
  }

  //check if date is low
  if (moment.utc(value).isAfter(minDate)) {
    return moment(value).format("DD-MM-YYYY");
  } else {
    return "Geen datum";
  }
});

Vue.filter("regularDateTimeClean", function (value) {
  value = String(value);
  if (isValidTimestamp(value))
    return moment.unix(value / 1000).format("DD MMMM YYYY HH:mm");

  return moment(value).format("DD MMMM YYYY HH:mm");
});

Vue.filter("regularHourTime", function (value) {
  value = String(value);
  if (isValidTimestamp(value)) return moment.unix(value / 1000).format("HH");

  return moment(value).format("HH");
});

Vue.filter("regularTime", function (value) {
  value = String(value);
  if (isValidTimestamp(value)) return moment.unix(value / 1000).format("HH:mm");

  return moment(value).format("HH:mm");
});

Vue.filter("regularDateTime", function (value) {
  value = String(value);
  if (isValidTimestamp(value))
    return moment.unix(value / 1000).format("DD-MM-YYYY HH:mm");

  return moment(value).format("DD-MM-YYYY HH:mm");
});

Vue.filter("regularMonthYear", function (value) {
  value = String(value);
  if (isValidTimestamp(value))
    return moment.unix(value / 1000).format("MMM YYYY");

  return moment(value).format("MMM YYYY");
});

Vue.filter("regularMonth", function (value) {
  value = String(value);
  if (isValidTimestamp(value))
    return moment.unix(value / 1000).format("MMM YYYY");

  return moment(value).format("MMMM");
});

Vue.filter("month", function (val, showYear = true) {
  val = String(val);

  const regx = /\w+\s(\w+)\s\d+\s(\d+)./;
  if (!showYear) {
    return regx.exec(val)[1];
  } else {
    return regx.exec(val)[1] + " " + regx.exec(val)[2];
  }
});

Vue.filter("formatRecipient", function (val) {
  val = String(val);

  if (val == "0") {
    return "Planner";
  }
  if (val == "1") {
    return "Docent";
  } else {
    return "Klant";
  }
});

Vue.filter("locationToReadable", function (obj) {
  if (typeof obj === "object" && obj !== null) {
    let pre = "incompany";
    let after = "";

    if (obj.psLocationId != null) {
      pre = "ps";
      after = obj.locationName;
    } else {
      if (obj.addToPs != undefined && obj.addToPs == true) {
        pre = "nieuw";
      }
      after = obj.address + " " + obj.city;
    }

    return `(${pre}) ${after}`;
  } else {
    return "geen locatie";
  }
});

Vue.filter("formatBoolToText", function (val, invert) {
  var valBool = val === "true";
  if (invert) valBool = !valBool;
  return valBool ? "Ja" : "Nee";
});

Vue.filter("validate_date_format_dutch", function (value) {
  const regx = new RegExp(
    "^([1-2][0-9]|3[0-1]|0?[1-9])[-]([1][0-2]|0?[1-9])[-]([0-9]{4})$"
  );

  // Check valid date using moment for both formats
  const dateFormats = ["DD-MM-YYYY", "D-M-YYYY"];
  const isValidFormat = dateFormats.some((format) =>
    moment(value, format, true).isValid()
  );

  return regx.exec(value) && isValidFormat;
});

Vue.filter("validate_time_format", function (value) {
  const regx = new RegExp("^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$");
  return regx.exec(value);
});

function isValidTimestamp(_timestamp) {
  return moment(_timestamp, "X", true).isValid();
}
